
import axios from "axios";
const API_URL = "https://api.externa.com";  

class CalculadoraService {

  obtenerCotizacion(peso, precio) {
    const ruta = `${API_URL}/calcular`;
    return axios.post(ruta, { peso, precio }, {
      headers: {
        'Content-Type': 'application/json',
        
      }
    })
      .then(response => response.data) 
      .catch(error => {
        console.error("Error en obtenerCotizacion:", error);
        throw error;
      });
  }


  /*class CalculadoraService {
    obtenerCotizacion(peso, precio) {
      const ruta = `${API_URL}/calcular?peso=${peso}&precio=${precio}`; 
      return axios.get(ruta, {
        headers: {
          'Content-Type': 'application/json',  // Opcional para GET
          // 'Authorization': `Bearer tu-token-aqui`,
        }
      })
      .then(response => response.data) 
      .catch(error => {
        console.error("Error en obtenerCotizacion:", error);
        throw error;
      });
    }
  }*/
  
}



export default new CalculadoraService();
